var React = require('react');

function HomeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M45 18L45 46 5 46 5 18","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M19 46L19 27 31 27 31 46","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M2,20L25,2.053l10.995,8.579C36,10.63,36,6,36,6h4c0,0,0,7.667,0.001,7.758L48,20","key":2}),React.createElement("path",{"d":"M27 35A1 1 0 1 0 27 37A1 1 0 1 0 27 35Z","key":3})]);
}

HomeInline.defaultProps = {"fill":"currentColor","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = HomeInline;

HomeInline.default = HomeInline;
